module.exports = "<p>\n  broker-pass works!\n</p>\n"